import { getLabels } from '@/modules/content/utils/getLabels';
import { ResourceTypeEnum } from '@/types/schema';

const RESOURCE_TYPE_LABEL_CONFIG = {
  [ResourceTypeEnum.LiveEventContent]: {
    title: 'Common:ResourceType.Live',
    createDescription: 'Common:ResourceType.Live',
  },
  [ResourceTypeEnum.ExternalEventContent]: {
    title: 'Common:ResourceType.External',
    createDescription: 'Common:ResourceType.External',
  },
  [ResourceTypeEnum.OfflineEventContent]: {
    title: 'Common:ResourceType.Offline',
    createDescription: 'Common:ResourceType.Offline',
  },
  [ResourceTypeEnum.RecurringLiveEventContent]: {
    title: 'Common:ResourceType.Live',
    createDescription: 'Common:ResourceType.Live',
  },
  [ResourceTypeEnum.RecurringExternalEventContent]: {
    title: 'Common:ResourceType.External',
    createDescription: 'Common:ResourceType.External',
  },
  [ResourceTypeEnum.RecurringOfflineEventContent]: {
    title: 'Common:ResourceType.Offline',
    createDescription: 'Common:ResourceType.Offline',
  },
  [ResourceTypeEnum.KnowledgeAsset]: getLabels('KnowledgeAsset'),
  [ResourceTypeEnum.Article]: getLabels('Article'),
  [ResourceTypeEnum.Course]: getLabels('Course'),
  [ResourceTypeEnum.MicroLearning]: getLabels('MicroLearning'),
  [ResourceTypeEnum.Checkin]: getLabels('Checkin'),
  [ResourceTypeEnum.Exercise]: getLabels('Exercise'),
  [ResourceTypeEnum.ExternalContent]: getLabels('ExternalContent'),
  [ResourceTypeEnum.Homework]: getLabels('Homework'),
  [ResourceTypeEnum.Path]: getLabels('Path'),
  [ResourceTypeEnum.Quiz]: getLabels('Quiz'),
  [ResourceTypeEnum.Scorm]: getLabels('Scorm'),
  [ResourceTypeEnum.Survey]: getLabels('Survey'),
  [ResourceTypeEnum.Task]: getLabels('Task'),
  [ResourceTypeEnum.Roleplay]: getLabels('Roleplay'),
};

export default RESOURCE_TYPE_LABEL_CONFIG;
